import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


export default function ConfirmDialog({title,description,handleClose}) {

    return (
            <Dialog
                open={true}
                onClose={()=>handleClose(false)}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {description}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={()=>handleClose(false)}>
                        ANNULLA
                    </Button>
                    <Button onClick={()=>handleClose(true)}>OK</Button>
                </DialogActions>
            </Dialog>

    );
}
